(function () {
  const ACTIVE_CLASS = 'is-active';
  const MOBILE_BREAKPOINT = '(max-width: 749px)';
  const MOBILE_CLASS_REGEX = /^grid--\d-col-tablet-down$/;
  const FACET_TRIGGER_SELECTOR = '[data-mobile-facets-trigger]';
  const FILTER_COUNTER_SELECTOR = '.filter-counter';
  const ACTIVE_FACETS_COUNT_SELECTOR = '[data-active-facets-count]';

  function setActiveState(options, value) {
    options.forEach((option) => {
      const isActive = option.dataset.columns === value;
      option.classList.toggle(ACTIVE_CLASS, isActive);
      option.setAttribute('aria-pressed', String(isActive));
      option.hidden = isActive;
      if (isActive) {
        option.setAttribute('aria-hidden', 'true');
        option.tabIndex = -1;
      } else {
        option.removeAttribute('aria-hidden');
        option.tabIndex = 0;
      }
    });
  }

  function initPicker(picker) {
    const targetSelector = picker.dataset.target;
    if (!targetSelector) return;

    const target = document.querySelector(targetSelector);
    if (!target) return;

    const options = Array.from(picker.querySelectorAll('[data-columns]'));
    if (!options.length) return;
    const originalMobileClass =
      Array.from(target.classList).find((className) => MOBILE_CLASS_REGEX.test(className)) || null;

    const storageKey = picker.dataset.storageKey || 'holsColumnPicker';
    const defaultColumns =
      picker.dataset.defaultMobileColumns ||
      picker.dataset.defaultColumns ||
      options[0].dataset.columns ||
      '2';
    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);

    function getStoredValue() {
      try {
        const stored = window.localStorage.getItem(storageKey);
        if (stored && options.some((option) => option.dataset.columns === stored)) {
          return stored;
        }
      } catch (error) {
        console.warn('column-picker: unable to access localStorage', error);
      }

      return null;
    }

    function removeMobileClasses() {
      Array.from(target.classList)
        .filter((className) => MOBILE_CLASS_REGEX.test(className))
        .forEach((className) => target.classList.remove(className));
    }

    function applyMobileColumns(columns) {
      if (!columns) return;
      removeMobileClasses();
      target.classList.add(`grid--${columns}-col-tablet-down`);
      target.dataset.currentColumns = columns;
    }

    function enableMobileMode() {
      const initialValue = getStoredValue() || defaultColumns;
      applyMobileColumns(initialValue);
      setActiveState(options, initialValue);
    }

    function disableMobileMode() {
      setActiveState(options, null);
      target.dataset.currentColumns = '';
      removeMobileClasses();
      if (originalMobileClass) {
        target.classList.add(originalMobileClass);
      }
    }

    if (mediaQuery.matches) {
      enableMobileMode();
    } else {
      disableMobileMode();
    }

    const handleBreakpointChange = (event) => {
      if (event.matches) {
        enableMobileMode();
      } else {
        disableMobileMode();
      }
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleBreakpointChange);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(handleBreakpointChange);
    }

    options.forEach((option) => {
      option.addEventListener('click', () => {
        if (!mediaQuery.matches) return;

        const columns = option.dataset.columns;
        if (!columns || columns === target.dataset.currentColumns) return;

        applyMobileColumns(columns);
        setActiveState(options, columns);
        const nextOption = options.find((opt) => !opt.hidden);
        if (nextOption) {
          window.requestAnimationFrame(() => nextOption.focus());
        }

        try {
          window.localStorage.setItem(storageKey, columns);
        } catch (error) {
          console.warn('column-picker: unable to persist selection', error);
        }
      });
    });
  }

  function getDrawerSummary(targetSelector) {
    if (!targetSelector) return null;
    const normalizedSelector = targetSelector.startsWith('#') ? targetSelector : `#${targetSelector}`;
    let drawer;
    try {
      drawer = document.querySelector(normalizedSelector);
    } catch (error) {
      console.warn('column-picker: invalid selector for mobile facets trigger', targetSelector, error);
      return null;
    }
    return drawer ? drawer.querySelector('summary') : null;
  }

  function initFacetTriggers() {
    const triggers = document.querySelectorAll(FACET_TRIGGER_SELECTOR);
    if (!triggers.length) return;

    triggers.forEach((trigger) => {
      const summary = getDrawerSummary(trigger.dataset.mobileFacetsTrigger);
      if (!summary) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const details = summary.closest('details');
        if (!details) return;

        if (details.hasAttribute('open')) {
          summary.focus();
          return;
        }

        summary.click();
      });
    });
  }

  function updateFilterCounter(count) {
    const counters = document.querySelectorAll(FILTER_COUNTER_SELECTOR);
    if (!counters.length) return;
    const value = `(${count})`;
    counters.forEach((counter) => {
      counter.textContent = value;
    });
  }

  function getCurrentActiveFacetsCount() {
    const source = document.querySelector(ACTIVE_FACETS_COUNT_SELECTOR);
    if (!source) return 0;
    const rawValue = source.getAttribute('data-active-facets-count');
    const parsedValue = rawValue !== null ? parseInt(rawValue, 10) : 0;
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
  }

  function initFilterCounter() {
    if (!document.querySelector(FILTER_COUNTER_SELECTOR)) return;
    updateFilterCounter(getCurrentActiveFacetsCount());
    document.addEventListener('facets:count-changed', (event) => {
      const count = typeof event.detail?.count === 'number' ? event.detail.count : 0;
      updateFilterCounter(count);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-column-picker]').forEach(initPicker);
    initFacetTriggers();
    initFilterCounter();
  });
})();
